import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as IlusIcon } from "../inlineSvgs/ilus-done.svg";

const CreateSuccessPage = () => {
  return (
    <div className="successPage">
      <IlusIcon />
      <div className="title">Create Account Success</div>
      <div className="sub-title">
        Congratulation! You have success creating account. We have send you an email to verify your account.
      </div>
      <div className="button-section">
        <Link to="/" className="beauty-btn fill white">
          Go to Homepage
        </Link>
        <Link to="/profile" className="beauty-btn border white">
          Go to Profile
        </Link>
      </div>
    </div>
  );
};

export default CreateSuccessPage;
